<template>
	<span @click="$emit('click')">{{ catalog.name }}</span>
</template>
<script>
	export default {
		props: {
			catalog: Object
		}
	}
</script>